import React, { FunctionComponent } from 'react';
import { InternalLink } from '../internal-link/internal-link';
import styles from './case-study-next.module.scss';
import { caseStudyArticleUrl } from '../../utils/utils';
import { emptyWyswigString } from '../../utils/utils';
import { useGlobalTranslations } from '../../hooks/use-global-translations';
import Arrow from '../../assets/images/cta-arrow.inline.svg';

export interface ICaseStudyNextProps {
  language: string;
  id: string;
  slug: string;
  summary: string;
  image: {
    url: string;
    name: string;
  };
}

const CaseStudyNextComponent: FunctionComponent<ICaseStudyNextProps> = props => {
  const {
    slug,
    summary,
    image: { url, name: alt }
  } = props;
  const { nextStoryText } = useGlobalTranslations();
  const articleUrl = caseStudyArticleUrl(slug);

  return (
    <InternalLink className={styles.articleWrapper} url={articleUrl}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.articleInfo}>
            <div className={styles.nextLink}>
              {nextStoryText}
              <span className={styles.arrow}>
                <Arrow />
              </span>
            </div>
            {summary !== emptyWyswigString && (
              <div
                className={styles.articleDescription}
                dangerouslySetInnerHTML={{ __html: summary }}
              ></div>
            )}
          </div>
          <div
            className={`${styles.imageWrapper} ${
              summary !== emptyWyswigString
                ? styles.bigImage
                : styles.smallImage
            }`}
          >
            <img className={styles.articleImage} src={url} alt={alt} />
          </div>
        </div>
      </div>
    </InternalLink>
  );
};

export const CaseStudyNext = React.memo(CaseStudyNextComponent);
